import MachineBase from './base/MachineBase';

/**
 * @class Machine
 * @extends MachineBase
 */
class Machine extends MachineBase {

}

export default Machine;
